import * as React from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {w100} from "@pg-design/helpers-css";
import {FILTERS_TEST_IDS} from "@pg-mono/e2e-test-utils";

interface IProps {
    onCancel: () => void;
    onSave: (e: React.MouseEvent<HTMLElement>) => void;
    submitText?: string;
    clearText?: string;
    acceptButtonTestId?: string;
}

export const FilterFooter: React.FunctionComponent<IProps> = ({onSave, onCancel, submitText = "Wybierz", clearText = "Wyczyść", acceptButtonTestId}) => {
    return (
        <div css={filterFooter}>
            <Button
                variant="filled_primary"
                onClick={onSave}
                size="small"
                css={fullWidthButton}
                dataTestId={acceptButtonTestId || FILTERS_TEST_IDS.ACCEPT_BUTTON}
            >
                {submitText}
            </Button>

            <Button type="button" variant="none_secondary" onClick={onCancel} size="small" css={w100} dataTestId={FILTERS_TEST_IDS.CLEAN_BUTTON}>
                {clearText}
            </Button>
        </div>
    );
};

const filterFooter = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`;

const fullWidthButton = css`
    width: 100%;
`;
import * as React from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {w100} from "@pg-design/helpers-css";
import {FILTERS_TEST_IDS} from "@pg-mono/e2e-test-utils";

interface IProps {
    onCancel: () => void;
    onSave: (e: React.MouseEvent<HTMLElement>) => void;
    submitText?: string;
    clearText?: string;
    acceptButtonTestId?: string;
}

export const FilterFooter: React.FunctionComponent<IProps> = ({onSave, onCancel, submitText = "Wybierz", clearText = "Wyczyść", acceptButtonTestId}) => {
    return (
        <div css={filterFooter}>
            <Button
                variant="filled_primary"
                onClick={onSave}
                size="small"
                css={fullWidthButton}
                dataTestId={acceptButtonTestId || FILTERS_TEST_IDS.ACCEPT_BUTTON}
            >
                {submitText}
            </Button>

            <Button type="button" variant="none_secondary" onClick={onCancel} size="small" css={w100} dataTestId={FILTERS_TEST_IDS.CLEAN_BUTTON}>
                {clearText}
            </Button>
        </div>
    );
};

const filterFooter = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`;

const fullWidthButton = css`
    width: 100%;
`;
